import { DEFAULT_DIALOG_CONFIG, DialogConfig } from '@angular/cdk/dialog';
import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, RouteReuseStrategy, withRouterConfig } from '@angular/router';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { routes } from './app.routes';
import { authHeaderInterceptor } from './common/interceptors/auth-headers.interceptor';
import { p0SubscriptionKeyInterceptor } from './common/interceptors/p0-subscription-key.interceptor';
import { CacheRouteReuseStrategy } from './common/route.strategy';

const defaultDialogConfig = new DialogConfig();
defaultDialogConfig.panelClass = 'eop-dialog-panel';

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideRouter(
			routes,
			withRouterConfig({
				// Ensure reload when access-related account state changes.
				onSameUrlNavigation: 'reload',
			}),
		),
		provideOAuthClient(),
		provideHttpClient(
			withInterceptors([
				// Order matters: subscription key first, then auth header
				p0SubscriptionKeyInterceptor,
				authHeaderInterceptor,
			]),
		),
		{
			provide: RouteReuseStrategy,
			useClass: CacheRouteReuseStrategy,
		},
		{
			provide: DEFAULT_DIALOG_CONFIG,
			useValue: defaultDialogConfig,
		},
		DatePipe,
	],
};
